import { useEffect, useState } from 'react'

import {
    ensureOfferConfigLoaded,
    isOfferConfigLoaded,
    subscribeToOfferConfig,
} from '@/utils/flights/pe/offerConfig'

import { getEliteUnlockSoonBenefits } from './helpers'

/**
 * Resolves Elite unlock-soon benefit tiles from offerJson.
 * Ensures offerSlot.js is loaded (needed on Confirmation, which does not load it itself).
 */
export function useEliteUnlockSoonBenefits(): string[] {
    const [benefits, setBenefits] = useState<string[]>(getEliteUnlockSoonBenefits)

    useEffect(() => {
        ensureOfferConfigLoaded()
        if (isOfferConfigLoaded()) {
            setBenefits(getEliteUnlockSoonBenefits())
        }
        return subscribeToOfferConfig(() => {
            setBenefits(getEliteUnlockSoonBenefits())
        })
    }, [])

    return benefits
}
